import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Blog(): ReactElement {
  return (
    <PageShell
      title="Blog"
      intro="Tipps zu Buchhaltung, Steuern und Selbstständigkeit – verständlich erklärt."
    >
      <PageSection title="Demnächst hier">
        <p>
          Wir arbeiten an Beiträgen rund um Rechnungen, Umsatzsteuer, EÜR,
          Belegerfassung und den Alltag als Selbstständige – praxisnah und ohne
          Fachchinesisch.
        </p>
      </PageSection>

      <PageSection title="Nichts verpassen">
        <p>
          Bis es losgeht: Abonnieren Sie unseren Newsletter im Seitenfuß oder
          schreiben Sie uns, welche Themen Sie interessieren – an{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>
          .
        </p>
      </PageSection>
    </PageShell>
  );
}
